import { Modal } from "@mui/material";
import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const ModalAccept = ({ open, handleClose, send }) => {
  return (
    <>
      <div
        className={`${
          open ? "fixed" : "hidden"
        } z-50 left-0  top-0  w-full h-full lg:hidden`}
      >
        <div
          onClick={() => {
            handleClose();
            localStorage.setItem("dontShow", new Date());
            send();
          }}
          className="absolute lg:hidden left-0  top-0 w-full h-full bg-[#000]/40"
        ></div>
        <div
          dir="rtl"
          className="rounded-[10px] min-w-[290px] z-[52] p-4 lg:text-[16px] text-[12px] outline-none absolute right-1/2 bottom-1/2 translate-y-1/2 border lg:translate-x-0 lg:translate-y-0 bg-[#ffffff] shadow-2xl lg:bottom-4 lg:right-4 translate-x-1/2"
        >
          <FaTimes
            onClick={() => {
              handleClose();
              localStorage.setItem("dontShow", new Date());
              send();
            }}
            className="text-red-500 cursor-pointer hidden lg:flex"
          />
          <div className="border-b pb-2 text-center">
            برای اطلاع از اخبار سایت در پنجره بعدی دکمه Allow رو انتخاب کنید
          </div>
          <div className="border-b py-2 text-center ">
            همینطور میتونی سایت رو به صورت وب اپ داشته باشی برای نصب اینجا{" "}
            <button id="install" className="font-bold text-red-500">
              کلیک
            </button>{" "}
            کن
          </div>
          <div className="border-b py-2 text-center ">
            <p className="mb-1">اگر ios هستید :</p>
            <div class="flex mb-1 flex-wrap">
              <span className="inline">1-در نوار پایین دکمه</span>
              <span className="inline">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="0"
                  viewBox="0 0 15 15"
                  color="blue"
                  height="15"
                  width="15"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3.5 5.00006C3.22386 5.00006 3 5.22392 3 5.50006L3 11.5001C3 11.7762 3.22386 12.0001 3.5 12.0001L11.5 12.0001C11.7761 12.0001 12 11.7762 12 11.5001L12 5.50006C12 5.22392 11.7761 5.00006 11.5 5.00006L10.25 5.00006C9.97386 5.00006 9.75 4.7762 9.75 4.50006C9.75 4.22392 9.97386 4.00006 10.25 4.00006L11.5 4.00006C12.3284 4.00006 13 4.67163 13 5.50006L13 11.5001C13 12.3285 12.3284 13.0001 11.5 13.0001L3.5 13.0001C2.67157 13.0001 2 12.3285 2 11.5001L2 5.50006C2 4.67163 2.67157 4.00006 3.5 4.00006L4.75 4.00006C5.02614 4.00006 5.25 4.22392 5.25 4.50006C5.25 4.7762 5.02614 5.00006 4.75 5.00006L3.5 5.00006ZM7 1.6364L5.5682 3.0682C5.39246 3.24393 5.10754 3.24393 4.9318 3.0682C4.75607 2.89246 4.75607 2.60754 4.9318 2.4318L7.1818 0.181802C7.26619 0.09741 7.38065 0.049999 7.5 0.049999C7.61935 0.049999 7.73381 0.09741 7.8182 0.181802L10.0682 2.4318C10.2439 2.60754 10.2439 2.89246 10.0682 3.0682C9.89246 3.24393 9.60754 3.24393 9.4318 3.0682L8 1.6364L8 8.5C8 8.77614 7.77614 9 7.5 9C7.22386 9 7 8.77614 7 8.5L7 1.6364Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </span>
              <span className="inline">«Share» را انتخاب کنید.</span>
            </div>
            <div class="flex mb-1 flex-wrap">
                <p class="whitespace-nowrap">2-در منو باز شده، گزینه ,</p>
                <div class="flex">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 15 15"
                    height="15"
                    width="15"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.5 1h12l.5.5v12l-.5.5h-12l-.5-.5v-12l.5-.5zM2 13h11V2H2v11z"
                    ></path>
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 4H7v3H4v1h3v3h1V8h3V7H8V4z"
                    ></path>
                  </svg>
                </div>
                <p class="whitespace-nowrap">«Add to home screen»</p>
                <p>را انتخاب کنید</p>
            </div>
            <p className="text-right">۳-در مرحله بعد “Add” را انتخاب کنید</p>
          </div>
          <button
            onClick={() => {
              handleClose();
              localStorage.setItem("dontShow", new Date());
              send();
            }}
            className=" mx-auto text-center flex justify-center pt-2 w-fit font-bold text-[14px] lg:text-[18px]"
          >
            باشه
          </button>
        </div>
      </div>
      <div
        dir="rtl"
        className={`rounded-[10px] z-50 p-4 lg:text-[16px] text-[12px]  outline-none ${
          open ? "lg:block lg:fixed hidden" : "hidden"
        }  right-1/2 bottom-1/2 translate-y-1/2 border lg:translate-x-0 lg:translate-y-0 bg-[#ffffff] shadow-2xl lg:bottom-4 lg:right-4 translate-x-1/2`}
      >
        <FaTimes
          onClick={() => {
            handleClose();
            localStorage.setItem("dontShow", new Date());
            send();
          }}
          className="text-red-500 cursor-pointer hidden lg:flex"
        />
        <div className="border-b py-2 text-center">
          برای اطلاع از اخبار سایت در پنجره بعدی دکمه Allow رو انتخاب کنید
        </div>

        <button
          onClick={() => {
            handleClose();
            localStorage.setItem("dontShow", new Date());
            send();
          }}
          className=" mx-auto text-center flex justify-center pt-2 w-fit font-bold text-[14px] lg:text-[18px]"
        >
          باشه
        </button>
      </div>
    </>
  );
};

export default ModalAccept;
